import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getDealType } from '../../selectors';
import { DealType } from '../../components/Filters';
import { EDealType } from '../../types/share';
import { updateCharts } from '../../actions/filters';

import { trackDealTypeFilterChange } from './tracking';

export function DealTypeContainer() {
  const dealType = useSelector(getDealType);
  const dispatch = useDispatch();

  const onChange = React.useCallback(
    (value: EDealType) => {
      if (value === dealType) {
        return;
      }

      dispatch(updateCharts('dealType', value));
      trackDealTypeFilterChange(value);
    },
    [dealType, dispatch],
  );

  return <DealType currentDealType={dealType} onChange={onChange} />;
}
